import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Row,
  Table,
  Alert,
  Spinner,
} from "reactstrap";
import { useNavigate } from "react-router-dom";
import ExpenseHeader from "../ExpenseDashboard/ExpenseHeader";
import { toast } from "react-toastify";
const AddUser = () => {
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [roles, setRoles] = useState([]);
  const [user, setUser] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    role: "",
  });
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ message: "", type: "" });

  // API URLs
  const GET_ROLES_URL = "https://api.hanoch.in/users/role-choices/";
  const POST_USER_URL = "https://api.hanoch.in/users/client/register/";
  const GET_USERS_URL =
    "https://api.hanoch.in/users/clients/?is_active=true";

  // 🔹 Fetch available roles
  const fetchRoles = async () => {
    try {
      const res = await axios.get(GET_ROLES_URL);
      setRoles(res.roles || []);
    } catch (error) {
      console.error("Error fetching roles:", error);
    }
  };
// 🔹 Deactivate User
const deactivateUser = async (userId) => {
  if (!window.confirm("Are you sure you want to deactivate this user?")) return;

  try {
    setLoading(true);
    await axios.patch(`https://api.hanoch.in/user/${userId}/activate/`, {
      is_active: false,
    });

    setAlert({
      message: `User ID ${userId} deactivated successfully`,
      type: "success",
    });

    // Refresh list
    fetchUsers();
  } catch (error) {
    console.error("Error deactivating user:", error);
    setAlert({
      message: "Failed to deactivate user",
      type: "danger",
    });
  } finally {
    setLoading(false);
  }
};

  // 🔹 Fetch existing users
  const fetchUsers = async () => {
    try {
      setLoading(true);
      const res = await axios.get(GET_USERS_URL);
      setUsers(res.data || []);
      console.log("usersss",res)
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchRoles();
    fetchUsers();
  }, []);

  // 🔹 Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  // 🔹 Submit user registration
  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, email, phone, password, role } = user;
    if (!name || !email || !phone || !password || !role) {
    
      return;
    }

    try {
      const res = await axios.post(POST_USER_URL, user);
      // Reset form
      setUser({ name: "", email: "", phone: "", password: "", role: "" });
toast.success("user added successfully");
      // Refresh user list

      fetchUsers();

    } catch (error) {
      console.error("Error adding user:", error);
       toast.error(error.response?.data?.message || "failed");
    }
  };

  return (
    <>
      {/* Header */}
      {/* <header className="dashboard-header shadow-sm">
        <Container
          fluid
          className="py-3 d-flex justify-content-between align-items-center"
        >
          <h3 className="m-0 fw-bold text-primary">User Management</h3>
          <Button
            color="secondary"
            size="sm"
            onClick={() => navigate("/addExpense")}
          >
            ← Back
          </Button>
        </Container>
      </header> */}

<ExpenseHeader/>
      <Container className="mt-4">
        {/* Alert Message */}
        {alert.message && (
          <Alert
            color={alert.type}
            toggle={() => setAlert({ message: "", type: "" })}
          >
            {alert.message}
          </Alert>
        )}

        {/* Add User Form */}
        <Card className="mb-4 shadow-sm">
          <CardTitle tag="h6" className="p-2 ">
           <h4 className="text-info"> Add New User</h4>
          </CardTitle>
          <CardBody>
            <Form onSubmit={handleSubmit}>
              <Row>
                <Col md={3}>
                  <FormGroup>
                    <Label>Name</Label>
                    <Input
                      type="text"
                      name="name"
                      value={user.name}
                      onChange={handleChange}
                      placeholder="Enter user name"
                    />
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Label>Email</Label>
                    <Input
                      type="email"
                      name="email"
                      value={user.email}
                      onChange={handleChange}
                      placeholder="Enter email"
                    />
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Label>Phone</Label>
                    <Input
                      type="text"
                      name="phone"
                      value={user.phone}
                      onChange={handleChange}
                      placeholder="Enter phone number"
                    />
                  </FormGroup>
                </Col>

                <Col md={3}>
                  <FormGroup>
                    <Label>Password</Label>
                    <Input
                      type="password"
                      name="password"
                      value={user.password}
                      onChange={handleChange}
                      placeholder="Enter password"
                    />
                  </FormGroup>
                </Col>
              </Row>

              <Row>
                <Col md={4}>
                  <FormGroup>
                    <Label>Role</Label>
                    <Input
                      type="select"
                      name="role"
                      value={user.role}
                      onChange={handleChange}
                    >
                      <option value="">Select Role</option>
                      {roles.map((r) => (
                        <option key={r.value} value={r.value}>
                          {r.label}
                        </option>
                      ))}
                    </Input>
                  </FormGroup>
                </Col>
              </Row>

              <div className="d-flex gap-2">
                <Button color="primary" type="submit">
                  Add User
                </Button>
              </div>
            </Form>
          </CardBody>
        </Card>

        {/* User List */}
        <Card className="shadow-sm">
          <CardHeader>Existing Users</CardHeader>
          <CardBody>
            {loading ? (
              <div className="text-center my-4">
                <Spinner color="primary" />
              </div>
            ) : (
              <Table bordered responsive hover>
  <thead className="table-light">
    <tr>
      
      <th>Name</th>
      <th>Email</th>
      <th>Phone</th>
      <th>Role</th>
      <th>Status</th>
      <th>Action</th>
    </tr>
  </thead>
  <tbody>
    {users.length > 0 ? (
      users.map((u) => (
        <tr key={u.id}>
          
          <td>{u.name}</td>
          <td>{u.email}</td>
          <td>{u.phone}</td>
          <td>{u.role}</td>
          <td>
            <span
              className={`badge rounded-pill ${
                u.is_active ? "bg-success" : "bg-danger"
              }`}
            >
              {u.is_active ? "Active" : "Inactive"}
            </span>
          </td>
          <td>
            {u.is_active ? (
              <Button
                color="danger"
                size="sm"
                onClick={() => deactivateUser(u.id)}
              >
                Deactivate
              </Button>
            ) : (
              <Button color="secondary" size="sm" disabled>
                Inactive
              </Button>
            )}
          </td>
        </tr>
      ))
    ) : (
      <tr>
        <td colSpan="7" className="text-center text-muted">
          No users found
        </td>
      </tr>
    )}
  </tbody>
</Table>

            )}
          </CardBody>
        </Card>
      </Container>
    </>
  );
};

export default AddUser;
